module.exports = __webpack_public_path__ + "media/images/usage-coupon-2-96ec3482a545ea1327ddd60132d1c92d.png";